
<app-casefilter-results [filterBy]="filterBy" [isFilterInAvailable]="true" 
[searchBy]="searchBy" [isSearchingAvailable]="true" (onApplyFilter)="applyFilter($event)"
(resetFilters)="onResetFilters()" [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)"></app-casefilter-results>